import { Container } from "react-bootstrap";
import { ColorsStyle } from "../../config/colors";

import Marquee from "../Marquee";

export default function LandingMarquee(){

	return (
		<Container fluid className="d-flex justify-content-center py-5">
			<div className="w-100 position-relative" style={{WebkitMaskImage: "linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 25%, rgba(0, 0, 0, 1) 75%, rgba(0, 0, 0, 0) 100%)"}}>
				<div className="position-absolute" style={{inset: 0, zIndex: 1, background: `linear-gradient(transparent, ${ColorsStyle.Grey800})`}}/>
				<Marquee text="Agendamento. Gestão. Vendas. Academy. Exclusividade. Comunidade. " className="text-primary fw-bold mb-2" style={{fontSize: 'clamp(3.5rem, 8vh + 1rem, 6rem)'}} />
				<Marquee text="Agenda Personalizada. Relatórios. Comissões. Ambiente de ensino. Aplicativo Web Exclusivo. Networking. " className="text-primary fw-bold mb-2" style={{fontSize: 'clamp(3rem, 5vh + 1rem, 4rem)'}} inverted />
				<Marquee text="Notificações Automáticas. Chat. Galeria de fotos. Programa de Fidelidade. Avaliações de Serviços. " className="text-primary fw-bold mb-2" style={{fontSize: 'clamp(3rem, 5vh + 1rem, 4rem)'}} />
				<Marquee text="Administração de Filiais. Gestão de barbeiros. Controle de lucros. Mapeamento financeiro. " className="text-primary fw-bold mb-2" style={{fontSize: 'clamp(3rem, 5vh + 1rem, 4rem)'}} inverted />
				<Marquee text="Evolução financeira. Qualidade de vida. Barbearia modernizada. Gestão simplificada. " className="text-primary fw-bold mb-2" style={{fontSize: 'clamp(3rem, 5vh + 1rem, 4rem)'}} />
			</div>
		</Container>
	)
}